// local
import Api from '.';

/**
 * Login the user with email and password.
 * @param {String} email The email.
 * @param {String} password The password.
 */
export function login(email, password) {
    const data = {
        email,
        password,
    };
    return Api.post('/auth/login', data, false);
}

/**
 * Obtain information about the current logged userd.
 */
export function loginWithToken() {
    return Api.post('/auth/me');
}

/**
 * Logout the user.
 */
export function logout() {
    return Api.post('/auth/logout');
}
